import { render, staticRenderFns } from "./GamesPage.vue?vue&type=template&id=c186d1fa&scoped=true&"
import script from "./GamesPage.vue?vue&type=script&lang=js&"
export * from "./GamesPage.vue?vue&type=script&lang=js&"
import style0 from "./GamesPage.vue?vue&type=style&index=0&id=c186d1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c186d1fa",
  null
  
)

export default component.exports